import { inject, Injectable } from '@angular/core';
import {
  Resolve,
  RouterStateSnapshot,
  ActivatedRouteSnapshot
} from '@angular/router';
import { catchError, Observable } from 'rxjs';
import { SubEventService } from '@doc/api/server-bo';

@Injectable({
  providedIn: 'root'
})
export class SubeventResolver implements Resolve<boolean> {
  private eventService = inject(SubEventService);
  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any> {
    return this.eventService.getAllSubEvents({}).pipe(
      catchError(error => {
        return [];
      })
    )
  }
}
